<template>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <span class="cursor-pointer flex items-center i18n-locale">
      <img class="lang-icon" :src="i18n_locale_img" :alt="$i18n.locale" />
      <span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span>
    </span>
    <vs-dropdown-menu
      class="w-48 i18n-dropdown vx-navbar-dropdown"
    >
      <vs-dropdown-item @click="updateLocale('en_US')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/en_US.png" alt="en" /> &nbsp;{{ getLocaleName('en_US') }}</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('zh_CN')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/zh_CN.png" alt="zh_CN" /> &nbsp;{{ getLocaleName('zh_CN') }}</vs-dropdown-item>
      <vs-dropdown-item @click="updateLocale('zh_Hant')"><img class="h-4 w-5 mr-1" src="@/assets/images/flags/zh_CN.png" alt="zh_Hant" /> &nbsp;{{ getLocaleName('zh_Hant') }}</vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { setLocalePreference, getLocaleNativeName } from '@/lang'
export default {
  computed: {
    ...mapGetters(['userInfo','agentRole','language','listRefresh']),
    i18n_locale_img() {
      return require(`@/assets/images/flags/${this.$i18n.locale}.png`)
    },
    getCurrentLocaleData() {
        const locale = this.$i18n.locale;
        return { lang: getLocaleNativeName(locale) }
    },
  },

  methods: {
    getLocaleName(locale) {
      return getLocaleNativeName(locale)
    },

    updateLocale(locale) {
      setLocalePreference(locale);
      this.$store.dispatch('setLanguage', locale);
      localStorage.setItem('isReadedCustomerInfo','');
      localStorage.setItem('isReadedAgentInfo','');
      const url = window.location.href.split('?')[0];
      window.location.href = url + '?lang=' + locale + '&t=' + Date.now();
    },
  }
}
</script>
<style lang="scss">
  .lang-icon {
    width: 2.14rem;
    height: 1.24rem;
  }
</style>
